module.exports = __webpack_public_path__ + "static/media/section-background.fd8e7c01.webp";